(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deals-direct-exclusives"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dd-exclusive-edit')) {
  customElements.define('dd-exclusive-edit', class extends HTMLElement {
    connectedCallback() {
      if (this._start || this._abort) return;
      this._start = requestAnimationFrame(() => {
        this._start = 0;
        if (this.isConnected) this.setup();
      });
    }
    setup() {
      if (this._abort) return;
      this._abort = new AbortController();
      const opts = { signal: this._abort.signal };
      this.rail = this.querySelector('.dde-rail');
      this.nav = this.querySelector('.dde-navigation');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => { this._frame = 0; this.update(); });
      };
      if (this.rail) {
        this.rail.addEventListener('scroll', this.schedule, { ...opts, passive: true });
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), opts));
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !this.swiping) return;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.rail.children[event.key === 'Home' ? 0 : this.rail.children.length - 1].scrollIntoView({ block: 'nearest', inline: 'start', behavior: this.behavior() });
          }
        }, opts);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.dde-card');
          if (card && this.swiping && this.rail.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, opts);
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this.schedule); this._resize.observe(this.rail);
        } else window.addEventListener('resize', this.schedule, opts);
        this.schedule();
      }
      if (this.classList.contains('dde-motion') && !this.motion.matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
        this._reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('dde-entering'); this._reveal.unobserve(entry.target); }
        }), { threshold: 0.08 });
        this.querySelectorAll('[data-reveal]').forEach(el => this._reveal.observe(el));
      }
    }
    behavior() { return this.classList.contains('dde-motion') && !this.motion.matches ? 'smooth' : 'auto'; }
    move(step) {
      if (!this.rail) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 14;
      const distance = this.rail.firstElementChild.getBoundingClientRect().width + gap;
      this.rail.scrollBy({ left: distance * step * (getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1), behavior: this.behavior() });
    }
    update() {
      if (!this.rail) return;
      const r = this.rail;
      this.swiping = getComputedStyle(r).overflowX === 'auto' && r.scrollWidth > r.clientWidth + 2;
      r.tabIndex = this.swiping ? 0 : -1;
      this.nav.hidden = !this.swiping;
      if (!this.swiping) return;
      const pos = Math.abs(r.scrollLeft), max = r.scrollWidth - r.clientWidth;
      this.nav.querySelector('[data-step="-1"]').disabled = pos < 2;
      this.nav.querySelector('[data-step="1"]').disabled = pos >= max - 2;
      const gap = parseFloat(getComputedStyle(r).columnGap) || 14;
      const width = r.firstElementChild.getBoundingClientRect().width + gap;
      const current = Math.min(r.children.length, Math.round(pos / width) + 1);
      this.nav.querySelector('.dde-progress').textContent = `${String(current).padStart(2,'0')} / ${String(r.children.length).padStart(2,'0')}`;
    }
    disconnectedCallback() {
      this._abort?.abort(); this._resize?.disconnect(); this._reveal?.disconnect(); cancelAnimationFrame(this._frame);
      cancelAnimationFrame(this._start); this._start = 0;
      this._abort = null; this._frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

	$('.featured-product-section .product__media-list').slick(getSliderSettings());

	$('.featured-product-section .product__media-sublist').each( function () {
		$(this).slick(getSubSliderProductSettings($(this).parent().find('.product__media-list')));
	});

	$('.featured-product-section .product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
		window.pauseAllMedia();
	});
	

	document.addEventListener('shopify:section:load', function (e) {
		$('.featured-product-section .product__media-list').not('.slick-initialized').slick(getSliderSettings());

		$('.featured-product-section .product__media-sublist').each( function () {
			$(this).not('.slick-initialized').slick(getSubSliderProductSettings($(this).parent().find('.product__media-list')));
		});

		$('.featured-product-section .product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
			window.pauseAllMedia();
		});
	});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
	}
}

customElements.define('sticky-header', StickyHeader);

const searchDetails = document.querySelector('.header__search details');
document.addEventListener('keyup', (e) => {
	if (e.key === 'Escape' && searchDetails) {
		searchDetails.removeAttribute('open');
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

$(document).ready(function () {

	$('.product-section .product__media-list').slick(getSliderSettings());

	$('.product-section .product__media-sublist').each( function () {
		$(this).slick(getSubSliderProductSettings($(this).parent().find('.product__media-list')));
	});

	$('.product-section .product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
		window.pauseAllMedia();
	});
});


  } catch(e) { console.error(e); }
})();
})();
